export function getEndOfDay(date?: Date): number {
  const valueDate = date ? new Date(date) : new Date();

  valueDate.setHours(24);
  valueDate.setMinutes(0);
  valueDate.setSeconds(0);

  return valueDate.setMilliseconds(0) - 1;
}
